import MissingVatNumberWarning from 'components/shared/missing-vat-number-warning/missing-vat-number-warning.component';
import { Box, Hidden, Step, StepLabel, Stepper } from '@mui/material';
import { selectedClinicsVar } from 'apollo/reactive-variables/invoice';
import React, { FC, Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateCollectiveInvoice from './create-collective-invoice.component';
import InvoiceSettingAndCompilation from './invoice-setting-and-compilation.component';
import { CONSTANTS } from 'config/constants';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { customerSettings } from 'utils/customerSettings';

const CreateInvoice: FC = () => {
    const { t: translate } = useTranslation(['orders']);
    const [isPtjOrg, setIsPtjOrg] = useState(false);
    const currentOrg = currentOrgVar();

    useEffect(() => {
        const isPtjOrg = customerSettings.getCustomerSetting(
            currentOrg?.customerSettings,
            CONSTANTS.SETTINGS_NAMES.PTJ_ORGANIZATION,
        );
        setIsPtjOrg(isPtjOrg);
        return () => {
            selectedClinicsVar({});
        };
    }, []);

    const [activeStep, setActiveStep] = React.useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleStepperCLick = (step: number) => {
        if (step < activeStep) {
            setActiveStep(step);
        }
    };

    function getSteps() {
        return ['CREATE_COLLECTIVE_INVOICES', 'INVOICE_SETTINGS_AND_COMPILATION'];
    }

    const steps = getSteps();

    function getStepContent(stepIndex: number) {
        switch (stepIndex) {
            case 0:
                return <CreateCollectiveInvoice handleNext={handleNext} />;
            case 1:
                return <InvoiceSettingAndCompilation isPtjOrg={isPtjOrg} handleBack={handleBack} />;
            default:
                return 'Unknown stepIndex';
        }
    }

    return (
        <Fragment>
            <Box mb={2}>
                <Hidden mdDown>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label, index) => (
                            <Step sx={{ cursor: 'pointer' }} key={index} onClick={() => handleStepperCLick(index)}>
                                <StepLabel>{translate(`orders:${label}`)}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Hidden>
            </Box>
            <MissingVatNumberWarning />
            <Box>
                <div>{getStepContent(activeStep)}</div>
            </Box>
        </Fragment>
    );
};

export default CreateInvoice;
